import React, { useState } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Input
} from "reactstrap";
import Papa from "papaparse";
import { importSpotHeroReport } from "helpers/fakebackend_helper";

const ImportSpotHeroReportModal = ({ isOpen, toggle }) => {
    const user = JSON.parse(localStorage.getItem("authUser"));
    const [file, setFile] = useState(null);
    const [parsedData, setParsedData] = useState([]);
    const [isCorrectFormat, setIsCorrectFormat] = useState(null);
    const [loading, setLoading] = useState(false);

    const requiredColumns = [
        "category",
        "rental id",
        "spot",
        "type",
        "starts",
        "ends",
        "ends day",
        "license plate",
        "total sale price",
        "reservation sale price",
        "oversize fee sale price",
        "gross remit",
        "refund",
        "manual adjustment",
        "refund or adjustment reason",
        "total remit",
        "reservation remit",
        "oversize fee remit",
        "effective month",
        "effective year",
        "transaction date",
        "timezone",
        "company",
        "spothero city",
        "company code",
        "facility id",
        "integration",
        "vendor rental id",
        "operator facility id",
        "currency",
        "event venue",
        "external_vendor_id",
        // "Location",
        // "SH Fee",
        // "SH Fee %",
    ];

    const handleFileChange = (e) => {
        const uploadedFile = e.target.files[0];
        setFile(uploadedFile);

        Papa.parse(uploadedFile, {
            header: true,
            skipEmptyLines: true,
            complete: function (results) {
                const rows = results.data;

                // Extract columns from CSV header
                const parsedColumns = results.meta.fields || [];

                // // Check if parsed columns match required columns exactly
                const hasAllRequired =
                    requiredColumns.every((col) => parsedColumns.includes(col)) &&
                    parsedColumns.every((col) => requiredColumns.includes(col));

                setIsCorrectFormat(hasAllRequired ? 1 : 0);
                // setIsCorrectFormat(1);

                setParsedData(rows);
            }
        });
    };

    const importData = async () => {
        try {
            setLoading(true);
            await importSpotHeroReport(user.token, parsedData);
        } catch (error) {
            console.error("Import failed:", error);
        } finally {
            toggle()
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>Import SpotHero Report</ModalHeader>
            <ModalBody>
                <Input type="file" onChange={handleFileChange} accept=".csv" />

                {file && (
                    <div className="mt-3">
                        <h6>File Information</h6>
                        <p className="mb-1">
                            <strong>Name:</strong> {file.name}
                        </p>
                        <p className="mb-1">
                            <strong>Size:</strong>{" "}
                            {(file.size / 1024 / 1024).toFixed(2)} MB
                        </p>
                        <p className="mb-1">
                            <strong>Type:</strong> {file.type || "N/A"}
                        </p>
                        <p className="mb-1">
                            <strong>Correct Format?:</strong>
                            {isCorrectFormat === 1 ? (
                                <span
                                    className="badge bg-success"
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: 10,
                                        padding: 5,
                                        color: "#FFFFFF",
                                        marginLeft: 10
                                    }}
                                >
                                    YES
                                </span>
                            ) : isCorrectFormat === 0 ? (
                                <span
                                    className="badge bg-danger"
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: 10,
                                        padding: 5,
                                        color: "#FFFFFF",
                                        marginLeft: 10
                                    }}
                                >
                                    NO, CONTACT DEVELOPER
                                </span>
                            ) : null}
                        </p>
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={toggle}>
                    Close
                </Button>
                {isCorrectFormat === 1 && (
                    <Button
                        color="primary"
                        onClick={importData}
                        disabled={loading}
                    >
                        {loading ? "Importing..." : "Import Data"}
                    </Button>
                )}
            </ModalFooter>
        </Modal>
    );
};

export default ImportSpotHeroReportModal;